import { put, takeLatest } from 'redux-saga/effects';

import { requestCityList } from '../../../services/city';
import { fetchCityListFailure, fetchCityListRequest, fetchCityListSuccess } from '../../reducers/city';

export function* watchCitySaga() {
  yield takeLatest(fetchCityListRequest, fetchCityList);
}

/**
 *
 * @param {*} param0
 */
function* fetchCityList({ payload }) {
  try {
    const response = yield requestCityList(payload);
    yield put(fetchCityListSuccess(response));
  } catch (error) {
    yield put(fetchCityListFailure('Failed to get list of Leads'));
  }
}
